import IConfigData from './IConfigData';

class ConfigService {
  private data: IConfigData = {};

  public addConfig(config: IConfigData) {
    this.data = { ...this.data, ...config };
  }

  public getItem(item: string): any {
    return this.data[item];
  }

  public setItem(item: string, itemData: any) {
    this.data[item] = itemData;
  }

  public getAll(): IConfigData {
    return this.data;
  }
}

export default ConfigService;
